import { Container, Row, Col } from "react-bootstrap";
import {
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import psebLogo from "../Assets/affiliations/pseb.png";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row style={{ alignItems: "center", justifyContent: "space-between", flexWrap: "nowrap", paddingLeft: "15px", paddingRight: "15px" }}>
        <Col xs="auto" md="3" className="footer-copywright" style={{ textAlign: "left", padding: "5px 0" }}>
          <h3 style={{ fontSize: "0.85em", margin: "0" }}>© {year} Al Fahad</h3>
        </Col>
        <Col xs="auto" md="6" className="footer-body d-none d-md-block" style={{ textAlign: "center" }}>
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/al-fahad/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
                title="LinkedIn"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="mailto:contact@alfahad.dev"
                style={{ color: "white" }}
                rel="noopener noreferrer"
                title="Email me"
              >
                <MdEmail />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/AlFahadPAK"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
                title="Twitter"
              >
                <AiOutlineTwitter />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/alfahadpak"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
                title="Instagram"
              >
                <AiFillInstagram />
              </a>
            </li>
          </ul>
        </Col>
        <Col xs="auto" md="3" style={{ textAlign: "right", display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "5px 0", flexWrap: "wrap" }} className="pseb-footer-col">
          <a
            href="https://portal.techdestination.com/verify-certificate/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyZWdpc3RyYXRpb25ObyI6IkZMMjEvUFNFQi8yMDI1LzIwMTUyIiwidHlwZSI6ImZyZWVsYW5jZXIiLCJpYXQiOjE3NjAzNjEzODAsImV4cCI6MTc2ODEzNzM4MH0.lsHZtwFVcHMHRJNsFmItZmJapQpoeMSU7hAALK75DU8"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-flex", alignItems: "center", textDecoration: "none", flexWrap: "wrap", justifyContent: "center" }}
          >
            <div style={{ 
              backgroundColor: "rgba(255, 255, 255, 0.95)", 
              padding: "2px", 
              borderRadius: "6px",
              marginRight: "8px",
              display: "inline-flex",
              alignItems: "center",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              flexShrink: 0
            }}>
              <img
                src={psebLogo}
                alt="PSEB Approved Freelancer"
                style={{
                  height: "25px",
                  width: "auto",
                  display: "block"
                }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <span style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.7em", lineHeight: "1.2" }}>
                PSEB Registration ID:
              </span>
              <span style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "0.7em", lineHeight: "1.2" }}>
                FL21/PSEB/2025/20152
              </span>
            </div>
          </a>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
